import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeFreeformAreaIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeFreeformArea" ref={ref} {...props}>
    <path d="M21.14,8.42c-1-2.06-4.56-3.21-7.16-4l-.35-.11c-2.77-.9-6.69-1.84-9,.27a.58.58,0,0,0-.12.1C3.24,6,3,7.9,3.27,9.85h0c0,.16,0,.32.07.49a23.76,23.76,0,0,0,.84,3.35l.12.35c.84,2.6,2,6.16,4.05,7.17a2.69,2.69,0,0,0,1.19.28,2.92,2.92,0,0,0,1-.19c2.11-.78,2.3-2.49,2.47-4a4.7,4.7,0,0,1,1.12-3.09,4.68,4.68,0,0,1,3.09-1.12c1.5-.16,3.21-.36,4-2.47A2.72,2.72,0,0,0,21.14,8.42Zm-1.31,1.7c-.44,1.19-1.25,1.34-2.75,1.5a6.83,6.83,0,0,0-3.4,1.06.75.75,0,0,0-1.43.32.75.75,0,0,0,.42.67,6.72,6.72,0,0,0-1.12,3.48c-.17,1.51-.31,2.31-1.5,2.75a1.25,1.25,0,0,1-1,0c-1.49-.73-2.57-4.07-3.29-6.28l-.11-.35C4.35,9.36,4.36,7,5.62,5.69s3.66-1.26,7.55,0l.34.11c2.22.71,5.56,1.79,6.29,3.28A1.25,1.25,0,0,1,19.83,10.12Zm-16.49.23A.68.68,0,0,1,3.25,10a.34.34,0,0,1,0-.14C3.29,10,3.31,10.18,3.34,10.35ZM7.75,7A.75.75,0,1,1,7,6.25.76.76,0,0,1,7.75,7Zm0,6A.75.75,0,1,1,7,12.25.76.76,0,0,1,7.75,13Zm3-3A.75.75,0,1,1,10,9.25.76.76,0,0,1,10.75,10Zm3-3A.75.75,0,1,1,13,6.25.76.76,0,0,1,13.75,7Zm-3,9a.75.75,0,1,1-.75-.75A.76.76,0,0,1,10.75,16Zm6-6A.75.75,0,1,1,16,9.25.76.76,0,0,1,16.75,10Z" />
  </Icon>
)) as IconWithRender;

ShapeFreeformAreaIcon.displayName = 'ShapeFreeformAreaIcon';
ShapeFreeformAreaIcon.renderIcon = (props) => (
  <ShapeFreeformAreaIcon {...props} />
);
export default ShapeFreeformAreaIcon;
